import { defineComponent as o, inject as r, createElementBlock as i, openBlock as n, unref as e, normalizeClass as c, renderSlot as d, createCommentVNode as m } from "vue";
import { D as l } from "./DescriptionList.keys-BHlHYV6b.js";
const p = ["data-variant"], w = {
  key: 0,
  class: "tw-hidden md:tw-inline"
}, k = /* @__PURE__ */ o({
  __name: "DescriptionListTerm",
  setup(_) {
    const s = r(l.key);
    if (!s)
      throw new Error("DescriptionListDetail must be used within a DescriptionList component.");
    const { variant: t } = s;
    return (a, u) => (n(), i("dt", {
      class: c(["stash-description-list-term tw-font-medium tw-text-ice-900", {
        "md:tw-max-w-40 md:tw-basis-2/5": e(t) === "columns",
        "tw-mr-1.5": e(t) === "inline",
        "tw-pb-1.5": e(t) === "stacked",
        "tw-pb-1.5 md:tw-pb-0": e(t) !== "stacked"
      }]),
      "data-test": "stash-description-list-term",
      "data-variant": e(t)
    }, [
      d(a.$slots, "default"),
      e(t) === "inline" ? (n(), i("span", w, ":")) : m("", !0)
    ], 10, p));
  }
});
export {
  k as default
};
//# sourceMappingURL=DescriptionListTerm.js.map
